/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var elem = document.querySelector('#buy-it');
var flkty = new Flickity( elem, {
  // options
  freeScroll: true,
    wrapAround: true,
    contain: true,
    autoPlay: 8000,
    pageDots: false, // advance cells every 3 seconds
});

// var logolist = document.querySelector('.logo_list_wrapper');
// var flkty = new Flickity( logolist, {
//   // options
//   freeScroll: true,
//     wrapAround: true,
//     contain: true,
//     autoPlay: 8000,
//     pageDots: false, // advance cells every 3 seconds
// });

// window.addEventListener('resize', function(event){
//   var logo_slider = document.querySelector('.logo_contaier');
//   // do stuff here
//   console.log("hi");
//    logo_slider.flickityInstance.resize();

// });
 
